var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8289 17.3684V18.5263C21.8289 19.1405 21.5849 19.7295 21.1506 20.1638C20.7163 20.5981 20.1273 20.8421 19.5131 20.8421H3.30261C2.68842 20.8421 2.09939 20.5981 1.6651 20.1638C1.2308 19.7295 0.986816 19.1405 0.986816 18.5263V2.31579C0.986816 1.7016 1.2308 1.11257 1.6651 0.678279C2.09939 0.243984 2.68842 0 3.30261 0H19.5131C20.1273 0 20.7163 0.243984 21.1506 0.678279C21.5849 1.11257 21.8289 1.7016 21.8289 2.31579V3.47368H11.4079C10.7937 3.47368 10.2047 3.71767 9.77036 4.15196C9.33606 4.58626 9.09208 5.17529 9.09208 5.78947V15.0526C9.09208 15.6668 9.33606 16.2558 9.77036 16.6901C10.2047 17.1244 10.7937 17.3684 11.4079 17.3684M11.4079 15.0526H22.9868V5.78947H11.4079M16.0394 12.1579C15.5788 12.1579 15.137 11.9749 14.8113 11.6492C14.4856 11.3235 14.3026 10.8817 14.3026 10.4211C14.3026 9.96041 14.4856 9.51864 14.8113 9.19292C15.137 8.8672 15.5788 8.68421 16.0394 8.68421C16.5001 8.68421 16.9419 8.8672 17.2676 9.19292C17.5933 9.51864 17.7763 9.96041 17.7763 10.4211C17.7763 10.8817 17.5933 11.3235 17.2676 11.6492C16.9419 11.9749 16.5001 12.1579 16.0394 12.1579Z",
    fill: "#1A74EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.c2ebe88d3d825f459f0185fc4ed8e7d2.svg";
export { ForwardRef as ReactComponent };